import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  monospace?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, invalid, monospace, ...rest }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        "flex min-h-[120px] w-full rounded-[var(--radius-md)] p-4 text-sm transition-all leading-relaxed",
        "glass placeholder:text-[var(--color-fg-tertiary)]",
        "focus:outline-none focus:border-[var(--color-brand-purple)] focus:ring-2 focus:ring-[var(--color-brand-purple-soft)]",
        "disabled:cursor-not-allowed disabled:opacity-50 resize-y",
        monospace && "font-mono text-xs leading-snug",
        invalid &&
          "border-[var(--color-danger)] focus:border-[var(--color-danger)] focus:ring-[var(--color-danger-soft)]",
        className,
      )}
      {...rest}
    />
  ),
);
Textarea.displayName = "Textarea";
